export const ACTION_TYPES = {
	UPDATE_GAMES_STATUS: "UPDATE_GAMES_STATUS",
};

export const updateGamesStatus = (data) => {
	localStorage.setItem("gamesStatus", JSON.stringify(data));

	return { type: ACTION_TYPES.UPDATE_GAMES_STATUS, payload: data };
};
